<template>
  <div>
    <div class="toolbtn flex" v-if="activeName == 'first'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refreshs()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <div class="toolbtn flex" v-if="activeName == 'second'">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refreshss()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumns()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <div class="width100 margin-auto border-rd3">
      <el-skeleton
        class="width100 backwhite"
        :loading="true"
        animated
        :throttle="500"
      >
        <template slot="template">
          <el-tabs
            v-model="activeName"
            class="width98 pad-top10 border-rd3 margin-auto"
          >
            <el-tab-pane label="独立认证项目" name="first">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3 flex-betweenwrap"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputs"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitForms()"
                      >检 索</el-button
                    >
                    <el-button @click="resetForms()">重 置</el-button>
                  </div>
                </el-form>
                <span
                  class="
                    attention
                    margin-top10 margin-bot10 margin-left20 margin-right20
                  "
                  @click="tohandles()"
                  >新 增</span
                >
              </div>
            </el-tab-pane>
            <el-tab-pane label="云盘认证项目" name="second">
              <!-- 关键词检索  -->
              <div
                class="width100 f14 backwhite border-rd3 flex-betweenwrap"
                style="min-height: 72px"
                v-if="serchkey"
              >
                <el-form
                  ref="ruleForm"
                  size="small"
                  label-width="60px"
                  class="demo-ruleForm flexleft"
                >
                  <el-form-item label="关键词">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputss"
                    ></el-input>
                  </el-form-item>
                  <div class="margin-left20 margin-top10 margin-bot10">
                    <el-button type="primary" @click="submitFormss()"
                      >检 索</el-button
                    >
                    <el-button @click="resetFormss()">重 置</el-button>
                  </div>
                </el-form>
                <span
                  class="
                    attention
                    margin-top10 margin-bot10 margin-left20 margin-right20
                  "
                  @click="tohandless()"
                  >新 增</span
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-skeleton>
      <el-skeleton
        v-if="activeName == 'first'"
        class="width100 backwhite border-rd3"
        :loading="loading"
        animated
        :throttle="500"
      >
        <template slot="template">
          <div
            class="
              width98
              backwhite
              pad-top20 pad-bot20
              margin-auto margin-auto margin-top15
              border-rd3
              alldigital
            "
            v-if="totals != 0"
          >
            <el-table
              :data="pages"
              stripe
              class="width100 eltable margin-auto f14"
            >
              <el-table-column
                label="资产名称"
                width="380"
                v-if="columns[0].visible"
              >
                <template slot-scope="scope">
                  <span class="f14 text-ellipsis"> {{ scope.row.title }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="org"
                label="认证机构"
                width="280"
                v-if="columns[1].visible"
              >
              </el-table-column>
              <el-table-column
                prop="file.size"
                label="文件大小"
                v-if="columns[2].visible"
              >
              </el-table-column>
              <el-table-column
                prop="file.create_time"
                label="认证日期"
                v-if="columns[3].visible"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                v-if="columns[4].visible"
                width="180"
              >
                <template slot-scope="scope">
                  <span
                    class="bluecolor cursorpointer"
                    @click="downloadbook(scope.row)"
                    >下载证书</span
                  >
                  <span
                    class="bluecolor cursorpointer margin-left10"
                    @click="designmoney(scope.row)"
                    >下载资产</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div
              class="flex-betweennowrap pad-top20 pad-right10"
              v-if="totals != 0"
            >
              <span class="bluecolor"></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChanges"
                @current-change="currentchanges"
                :current-page="currentPages"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_pages"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totals"
                background
              >
              </el-pagination>
            </div>
          </div>
          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="totals == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
              ><p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p></el-empty
            >
          </div>
        </template>
      </el-skeleton>
      <el-skeleton
        v-if="activeName == 'second'"
        class="width100 backwhite border-rd3"
        :loading="loading"
        animated
        :throttle="500"
      >
        <template slot="template">
          <div
            class="
              width98
              backwhite
              pad-top20 pad-bot20
              margin-auto margin-auto margin-top15
              border-rd3
              alldigital
            "
            v-if="totalss != 0"
          >
            <el-table
              :data="pagess"
              stripe
              class="width100 eltable margin-auto f14"
            >
              <el-table-column
                label="资产名称"
                width="380"
                v-if="columnss[0].visible"
              >
                <template slot-scope="scope">
                  <span class="f14 text-ellipsis">
                    {{ scope.row.identification.title }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="identification.org"
                label="认证机构"
                width="280"
                v-if="columnss[1].visible"
              >
              </el-table-column>
              <el-table-column
                prop="size"
                label="文件大小"
                v-if="columnss[2].visible"
              >
              </el-table-column>
              <el-table-column
                prop="identification.create_time"
                label="认证日期"
                v-if="columnss[3].visible"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="操作"
                v-if="columnss[4].visible"
                width="180"
              >
                <template slot-scope="scope">
                  <span
                    class="bluecolor cursorpointer"
                    @click="downloadbooks(scope.row)"
                    >下载证书</span
                  >
                  <span
                    class="bluecolor cursorpointer margin-left10"
                    @click="designmoneys(scope.row)"
                    >下载资产</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div
              class="flex-betweennowrap pad-top20 pad-right10"
              v-if="totalss != 0"
            >
              <span class="bluecolor"></span>
              <el-pagination
                :hide-on-single-page="true"
                @size-change="handleSizeChangess"
                @current-change="currentchangess"
                :current-page="currentPagess"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="per_pagess"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalss"
                background
              >
              </el-pagination>
            </div>
          </div>
          <div
            class="width100 margin-auto backgroudFFF margin-top15"
            v-if="totalss == 0"
          >
            <el-empty
              :image="require('@/assets/barsvg/zwsj@3x.png')"
              :image-size="200"
              description="抱歉，没有搜到您想要的内容"
              class="heightempty"
              ><p style="position: relative; bottom: 60px" class="f14">
                暂无数据
              </p></el-empty
            >
          </div>
        </template>
      </el-skeleton>

      <!-- 新增 -->
      <el-dialog
        title=""
        :visible.sync="dialogVisibleadd"
        :close-on-click-modal="false"
        :show-close="true"
        :center="true"
        :modal="true"
        :modal-append-to-body="true"
        :append-to-body="true"
        width="30%"
        class="errorboxs"
      >
        <applicationadd></applicationadd>
      </el-dialog>
      <el-dialog
        title=""
        :visible.sync="dialogVisiblenull"
        :close-on-click-modal="false"
        :show-close="true"
        :center="true"
        :modal="true"
        :modal-append-to-body="true"
        :append-to-body="true"
        width="25%"
        class="errorbox"
      >
        <span class="errormessage">{{ errormessage }}</span>
        <span slot="footer" class="dialog-footer">
          <button @click="dialogVisiblenull = false" class="errorbutton">
            确 定
          </button>
        </span>
      </el-dialog>
      <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
        <el-transfer
          :titles="['全选', '全选']"
          v-model="value"
          :data="columns"
          @change="dataChange"
        ></el-transfer>
      </el-dialog>
      <el-dialog
        :title="titles"
        :visible.sync="opens"
        append-to-body
        width="40%"
      >
        <el-transfer
          :titles="['全选', '全选']"
          v-model="values"
          :data="columnss"
          @change="dataChanges"
        ></el-transfer>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import { makerindex, documentcertfile } from "@/api/patent/patent.api";
import applicationadd from "./Application-certification.vue";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      loading: true,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleadd: false,
      thisNums: 1,
      thisNumss: 1,
      pages: [],
      pagess: [],
      totals: 0,
      totalss: 0,
      per_pages: 0,
      per_pagess: 0,
      currentPages: 1,
      currentPagess: 1,
      paginations: false,
      paginationss: false,
      centerDialogVisible: false,
      Remind: 0,
      behalf: 0,
      sell: 0,
      date: "",
      serchkey: true,
      inputs: "",
      inputss: "",
      activeName: "first",
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      columns: [
        { key: 0, label: `资产名称`, visible: true },
        { key: 1, label: `认证机构`, visible: true },
        { key: 2, label: `文件大小`, visible: true },
        { key: 3, label: `认证日期`, visible: true },
        { key: 4, label: `操作`, visible: true },
      ],
      // 显隐数据
      values: [],
      // 弹出层标题
      titles: "显示/隐藏",
      // 是否显示弹出层
      opens: false,
      columnss: [
        { key: 0, label: `资产名称`, visible: true },
        { key: 1, label: `认证机构`, visible: true },
        { key: 2, label: `文件大小`, visible: true },
        { key: 3, label: `认证日期`, visible: true },
        { key: 4, label: `操作`, visible: true },
      ],
    };
  },
  components: {
    callback,
    switchcore,
    applicationadd,
  },

  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    // 右侧列表元素变化
    dataChanges(data) {
      for (let item in this.columnss) {
        const key = this.columns[item].key;
        this.columnss[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumns() {
      this.opens = true;
    },
    // 第一个分页专利
    currentchanges(val) {
      this.thisNums = val;
      makerindex({
        page: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.status == 1) {
              i.status = "未认证";
            } else if (i.status == 2) {
              i.status = "认证中";
            } else if (i.status == 3) {
              i.status = "已实名";
            } else {
              i.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChanges(val) {
      makerindex({
        page: 1,
        limit: val,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.status == 1) {
              i.status = "未认证";
            } else if (i.status == 2) {
              i.status = "认证中";
            } else if (i.status == 3) {
              i.status = "已实名";
            } else {
              i.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页软著
    currentchangess(val) {
      this.thisNumss = val;
      // 获取云盘中已认证的文件
      documentcertfile({ page: val }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
          this.pagess.forEach((i) => {
            if (i.identification.status == 1) {
              i.identification.status = "未认证";
            } else if (i.identification.status == 2) {
              i.identification.status = "认证中";
            } else if (i.identification.status == 3) {
              i.identification.status = "已实名";
            } else {
              i.identification.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChangess(val) {
      documentcertfile({ page: this.thisNumss, limit: val }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
          this.pagess.forEach((i) => {
            if (i.identification.status == 1) {
              i.identification.status = "未认证";
            } else if (i.identification.status == 2) {
              i.identification.status = "认证中";
            } else if (i.identification.status == 3) {
              i.identification.status = "已实名";
            } else {
              i.identification.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // input重 置专利
    resetForms() {
      this.inputs = null;
      makerindex({
        page: this.thisNums,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.status == 1) {
              i.status = "未认证";
            } else if (i.status == 2) {
              i.status = "认证中";
            } else if (i.status == 3) {
              i.status = "已实名";
            } else {
              i.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    resetFormss() {
      this.inputss = null;
      // 获取云盘中已认证的文件
      documentcertfile({ page: this.thisNumss }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
          this.pagess.forEach((i) => {
            if (i.identification.status == 1) {
              i.identification.status = "未认证";
            } else if (i.identification.status == 2) {
              i.identification.status = "认证中";
            } else if (i.identification.status == 3) {
              i.identification.status = "已实名";
            } else {
              i.identification.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitForms() {
      makerindex({ _keywords: this.inputs }).then((res) => {
        if (res.data.code == 200) {
          this.pages = res.data.data.data;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.status == 1) {
              i.status = "未认证";
            } else if (i.status == 2) {
              i.status = "认证中";
            } else if (i.status == 3) {
              i.status = "已实名";
            } else {
              i.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 关键词检索
    submitFormss() {
      documentcertfile({ _keywords: this.inputss }).then((res) => {
        if (res.data.code == 200) {
          this.pagess = res.data.data.data;
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
          this.pagess.forEach((i) => {
            if (i.identification.status == 1) {
              i.identification.status = "未认证";
            } else if (i.identification.status == 2) {
              i.identification.status = "认证中";
            } else if (i.identification.status == 3) {
              i.identification.status = "已实名";
            } else {
              i.identification.status = "未认证";
            }
          });
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },

    tohandles() {
      this.dialogVisibleadd = true;
    },
    tohandless() {
      this.dialogVisibleadd = true;
    },
    // 下载证书
    downloadbook(row) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = window.g.Apisrc + row.file.url;
      document.body.appendChild(a);
      a.click();
    },
    downloadbooks(row) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = window.g.Apisrc + row.file.url;
      document.body.appendChild(a);
      a.click();
    },
    // 下载资产
    designmoney(row) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = window.g.Apisrc + row.url;
      document.body.appendChild(a);
      a.click();
    },
    designmoneys(row) {
      let a = document.createElement("a");
      a.style.display = "none";
      a.download = name;
      a.href = window.g.Apisrc + row.url;
      document.body.appendChild(a);
      a.click();
    },
    refreshs() {
      this.$loading.show(); // 显示loading
      // 获取原创认证列表
      makerindex({
        page: this.thisNums,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pages = res.data.data.data;
          this.paginations = true;
          this.totals = res.data.data.total;
          this.per_pages = res.data.data.per_page;
          this.pages.forEach((i) => {
            if (i.status == 1) {
              i.status = "未认证";
            } else if (i.status == 2) {
              i.status = "认证中";
            } else if (i.status == 3) {
              i.status = "已实名";
            } else {
              i.status = "未认证";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refreshss() {
      this.$loading.show(); // 显示loading
      // 获取云盘中已认证的文件
      documentcertfile({ page: this.thisNumss }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagess = res.data.data.data;
          this.paginationss = true;
          this.totalss = res.data.data.total;
          this.per_pagess = res.data.data.per_page;
          this.pagess.forEach((i) => {
            if (i.identification.status == 1) {
              i.identification.status = "未认证";
            } else if (i.identification.status == 2) {
              i.identification.status = "认证中";
            } else if (i.identification.status == 3) {
              i.identification.status = "已实名";
            } else {
              i.identification.status = "未认证";
            }
          });
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },

  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    // 获取原创认证列表
    makerindex({
      page: this.thisNums,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pages = res.data.data.data;
        this.paginations = true;
        this.totals = res.data.data.total;
        this.per_pages = res.data.data.per_page;
        this.pages.forEach((i) => {
          if (i.status == 1) {
            i.status = "未认证";
          } else if (i.status == 2) {
            i.status = "认证中";
          } else if (i.status == 3) {
            i.status = "已实名";
          } else {
            i.status = "未认证";
          }
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取云盘中已认证的文件
    documentcertfile({ page: this.thisNumss }).then((res) => {
      if (res.data.code == 200) {
        this.pagess = res.data.data.data;
        this.paginationss = true;
        this.totalss = res.data.data.total;
        this.per_pagess = res.data.data.per_page;
        this.pagess.forEach((i) => {
          if (i.identification.status == 1) {
            i.identification.status = "未认证";
          } else if (i.identification.status == 2) {
            i.identification.status = "认证中";
          } else if (i.identification.status == 3) {
            i.identification.status = "已实名";
          } else {
            i.identification.status = "未认证";
          }
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("applicationcer", (data) => {
      if (data == "yes") {
        this.dialogVisibleadd = false;
        this.refreshs();
        this.refreshss();
      } else {
        this.dialogVisibleadd = false;
      }
    });
  },
};
</script>
<style scoped>
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
  color: #6a7589;
}
.hovercont:hover {
  background: #f7f9fc;
}
.borcenter {
  border-left: 2px solid #efefef;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>